module.exports = autosize;


//////////////////
// WEBPACK FOOTER
// external "autosize"
// module id = Y9iB
// module chunks = 21